import { HTMLAttributes, createElement } from 'react';
import './b2chat-logo_style.css';
import BSvg from './logo-variant-b';
import B2ChatSvg from './logo-variant-b2chat';

type Variant =
  | `B-${'blue' | 'gray' | 'white'}`
  | `B2Chat-${'blue' | 'white' | 'green'}`;

export type B2ChatLogoProps = {
  variant: Variant;
} & HTMLAttributes<HTMLDivElement>;

const B2ChatLogo: React.FC<B2ChatLogoProps> = ({
  className,
  variant,
  ...attrs
}) => (
  <div
    {...attrs}
    className={`b2chat-logo ${className} variant-${variant} ${
      attrs?.onClick && 'pointer'
    }`}
  >
    {createElement(variant.startsWith('B2Chat') ? B2ChatSvg : BSvg)}
  </div>
);

export default B2ChatLogo;
